module.exports = __webpack_public_path__ + "static/media/rentRates2BedRoom-allDwelling-01.8dec2702.png";